// extracted by mini-css-extract-plugin
export default {"Photo":"style_Photo__uhq-V","TextComponent":"style_TextComponent__1OuRV"};